export default "__VITE_ASSET__B$KmCKHm__"